import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { isExtensionNoise } from '@/lib/extensionNoise.js'

// Fallback: ruído de extensões do Chrome (handler principal em index.html, antes do bundle)
window.addEventListener(
  'unhandledrejection',
  (event) => {
    if (isExtensionNoise(event.reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);
window.addEventListener(
  'error',
  (event) => {
    if (isExtensionNoise(event.message || event.error)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>,
)

if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    try {
      window.parent?.postMessage({ type: 'sandbox:beforeUpdate' }, '*');
    } catch (e) {
      // Ignorar erros de postMessage (extensões do navegador)
    }
  });
  import.meta.hot.on('vite:afterUpdate', () => {
    try {
      window.parent?.postMessage({ type: 'sandbox:afterUpdate' }, '*');
    } catch (e) {
      // Ignorar erros de postMessage (extensões do navegador)
    }
  });
}



